/** The tooltip box for a hand-drawn chart; `state` comes from useTip() in kit.js. */
export default function ChartTip({ state }) {
  if (!state) return null
  return (
    <div role="status" className="pointer-events-none absolute z-30 rounded-xl border border-gray-200 bg-white/95 backdrop-blur px-3 py-2 text-xs shadow-lg"
         style={{ left: Math.max(4, Math.min(state.x + 14, state.w - 230)), top: Math.max(0, state.y - 12), maxWidth: 240 }}>
      {state.content}
    </div>
  )
}
